import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			flexDirection: 'column-reverse',
			[theme.breakpoints.up('md')]: {
				flexDirection: 'row',
			},
		},
		container: {
			[theme.breakpoints.down('xs')]: {
				width: `calc(100% + ${theme.spacing(4)})`,
				margin: theme.spacing(-2.5, -2),
			},
		},
		text: ({ metaData }) => ({
			textAlign: 'center',
			[metaData.textPosition.isRightAlignment ? 'marginBottom' : 'marginTop']: theme.spacing(3),
			[theme.breakpoints.up('md')]: {
				textAlign: ({ metaData: { textPosition } }) => (textPosition.isRightAlignment ? 'left' : 'right'),
				marginTop: 0,
				marginBottom: 0,
			},

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData: { mobileAlignment } }) => {
						const alignment = mobileAlignment?.metaValue

						return alignment ? `${alignment} !important` : null
					},
				},
			},
		}),
	}),
	{ name: 'Content-Content5' },
)

export default useStyles
